/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.AutoBalanceTransferResponse, (requestParams: vp.AutoBalanceTransferRequest) => void, () => void];

function useFetchAutoBalanceTransfer({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.AutoBalanceTransferRequest>();
  const [response, setResponse] = useState<vp.AutoBalanceTransferResponse>({
    ErrorMessage: '',
    Success: false,
    AccountNumber: '',
    AutoBalanceTransferAmount: '',
    BranchTransitNumber: '',
    ABARoutingNumber: '',
    FinancialInstitutionNumber: '',
    AccountHolderName: '',
    NameOfFrequency: '',
    ScheduleStartDate: '',
    Status: '',
    Currency: '',
    Description: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.AutoBalanceTransferRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchAutoBalanceTransfer(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.AutoBalanceTransferRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse({
        ErrorMessage: '',
        Success: false,
        AccountNumber: '',
        AutoBalanceTransferAmount: '',
        BranchTransitNumber: '',
        ABARoutingNumber: '',
        FinancialInstitutionNumber: '',
        AccountHolderName: '',
        NameOfFrequency: '',
        ScheduleStartDate: '',
        Status: '',
        Currency: '',
        Description: '',
      });
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchAutoBalanceTransfer);
